import { render } from "./AddEditCustomer.vue?vue&type=template&id=53660e8a"
import script from "./AddEditCustomer.vue?vue&type=script&lang=js"
export * from "./AddEditCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__